import { useCallback } from 'react'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import {
  useGetInvoicePreviewData,
  UseGetInvoicePreviewDataProps,
} from '@features/invoices/hooks/useGetInvoicePreviewData'

import { InvoiceSettingsForm } from '../../../types/invoiceSettingsForm'
import { useInvoiceSettingsPreviewPayload } from './useInvoiceSettingsPreviewPayload'

type UseInvoicePreviewProps = UseGetInvoicePreviewDataProps

export const useInvoiceSettingsPreview = ({ onSuccess }: UseInvoicePreviewProps) => {
  const { getInvoiceSettingsPreviewPayload } = useInvoiceSettingsPreviewPayload()
  const { getInvoicePreviewData, isLoading } = useGetInvoicePreviewData({ onSuccess })

  const getInvoiceSettingsPreview = useCallback(
    (formValues: InvoiceSettingsForm) => {
      const invoiceSettingsPreviewPayload = getInvoiceSettingsPreviewPayload(formValues)

      return getInvoicePreviewData({
        documentType: InvoiceDocumentType.Invoice,
        payload: invoiceSettingsPreviewPayload,
      })
    },
    [getInvoicePreviewData, getInvoiceSettingsPreviewPayload],
  )

  return { getInvoiceSettingsPreview, isLoading }
}
